import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './StepIndicator.module.css';
export const StepIndicator = ({ total, current, activeWidth = 36, dotSize = 8, height = 8, gap = 10, style, className, 'data-testid': dataTestId, }) => {
    const clamped = Math.max(0, Math.min(current, total - 1));
    const dotKeys = Array.from({ length: total }, (_, i) => `dot-${i}`);
    return (_jsx("nav", { "aria-label": 'Progresso', className: `${styles.stepIndicator} ${className ?? ''}`, style: { gap, ...style }, "data-testid": dataTestId, children: dotKeys.map((dotKey, i) => {
            const isActive = i === clamped;
            const width = isActive ? activeWidth : dotSize;
            return (_jsx("div", { className: `${styles.stepIndicatorDot} ${isActive ? styles.active : ''}`, style: {
                    width,
                    height,
                    borderRadius: height / 2,
                }, "data-testid": `${dataTestId}-dot-${i}`, "aria-current": isActive ? 'step' : undefined }, dotKey));
        }) }));
};
